import type { AnswerValue, Question } from "@/schema/quizSchema";
import { SingleChoice } from "@/components/screens/SingleChoice";
import { MultiChoice } from "@/components/screens/MultiChoice";
import { Slider } from "@/components/screens/Slider";
import { TextInput } from "@/components/screens/TextInput";
import { NumberInput } from "@/components/screens/NumberInput";
import { Info } from "@/components/screens/Info";
import { WhyWeAsk } from "@/components/screens/WhyWeAsk";

function Screen({
  question,
  value,
  onAnswer,
}: {
  question: Question;
  value: AnswerValue | undefined;
  onAnswer: (value: AnswerValue) => void;
}) {
  switch (question.type) {
    case "single":
      return <SingleChoice question={question} value={value as string | undefined} onAnswer={onAnswer} />;
    case "multi":
      return <MultiChoice question={question} value={value as string[] | undefined} onAnswer={onAnswer} />;
    case "slider":
      return <Slider question={question} value={value as number | undefined} onAnswer={onAnswer} />;
    case "text":
      return <TextInput question={question} value={value as string | undefined} onAnswer={onAnswer} />;
    case "number":
      return <NumberInput question={question} value={value as number | null | undefined} onAnswer={onAnswer} />;
    case "info":
      return <Info question={question} onAnswer={onAnswer} />;
  }
}

export function QuestionView({
  question,
  value,
  onAnswer,
}: {
  question: Question;
  value: AnswerValue | undefined;
  onAnswer: (value: AnswerValue) => void;
}) {
  // `whyWeAsk` lives in baseFields (any question type may carry it) — render the
  // shared disclosure under whichever screen the question resolves to.
  return (
    <>
      <Screen question={question} value={value} onAnswer={onAnswer} />
      {question.whyWeAsk && <WhyWeAsk text={question.whyWeAsk} />}
    </>
  );
}
